export function readByte(buffer) {
  return buffer.readUInt8();
}